import {MutationCache, QueryCache, QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactNode} from 'react'
import {useFailureNotifier} from './Toaster'

type Props = {
  children: ReactNode
}

export const Queries = ({children}: Props) => {
  const notify = useFailureNotifier()

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        console.error(error)
        if (!query?.meta?.silent) {
          notify(error.message)
        }
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, variables, contex, mutation) => {
        console.error(error)
        if (!mutation?.meta?.silent) {
          notify(error.message)
        }
      },
    }),
  })

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
